module.exports = __webpack_public_path__ + "static/media/thumb-visual-design-club.fdab25c1.png";